import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    personalInfo: localStorage.getItem("personalInfo") ? JSON.parse(localStorage.getItem("personalInfo")) : [],
    loadingPersonalInfo: false
};

const loadPersonalInfo = (state) => {
    return {
        ...state,
        loadingPersonalInfo: true
    }
}

const setPersonalInfo = ( state, action ) => {
    let tmp = {...action.personalInfo}
    localStorage.setItem("personalInfo", JSON.stringify(tmp));
    return {
        ...state,
        personalInfo: tmp,
        loadingPersonalInfo: false
    }
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_PERSONAL_DATA: return loadPersonalInfo( state );
        case actionTypes.SET_PERSONAL_DATA: return setPersonalInfo( state, action );
        default: return state;
    }
};
export default reducer;